<div>
  <span class="qb-activation-header">ACTIVATION MODE for {{entityName}}</span>
</div>
<div class="qb-activation-container">
  <prox-ag-grid [gridOptions]="gridOptions" [rowData]="activationErrors"></prox-ag-grid>
</div>
